var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 15.334 0 L 20 4.701 L 20 17 L 17 17 L 17 20 L 0 20 L 0 3 L 3 3 L 3 0 L 15.334 0 Z M 15.5 18.5 L 15.5 8.319 L 11.709 4.5 L 1.5 4.5 L 1.5 18.5 L 15.5 18.5 Z M 18.5 15.5 L 18.5 5.319 L 14.709 1.5 L 4.5 1.5 L 4.5 3 L 12.334 3 L 17 7.701 L 17 15.5 L 18.5 15.5 Z",
    transform: "matrix(1, 0, 0, 1, 4.440892098500626e-16, 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyDocument);
export default __webpack_public_path__ + "static/media/copy-document.b64b70a63f20bff4928b267037e36b8b.svg";
export { ForwardRef as ReactComponent };